import { Icon, type IconTone } from './Icon';

/** Внимание: сота с восклицательным знаком. Шапка карточки «доступа нет». */
export function WarningIcon({ size = 15, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={18} tone={tone}>
      <path d="M9 1.2 L16.2 5.4 V13.6 L9 17.8 L1.8 13.6 V5.4 Z" strokeWidth={1.1} />
      <path d="M9 6.4 v3.6" strokeWidth={1.3} />
      <path d="M9 12.6 v0.2" strokeWidth={1.6} />
    </Icon>
  );
}
